import { AfterViewInit, Component, Inject, OnInit } from "@angular/core";

// Services
import { SharedService } from "./services/shared.service";
import { I18nService } from "./services/i18n.service";
import { CommonModule, DOCUMENT } from "@angular/common";
import { environment } from "../environments/environment";
import { ModalMessage, TypeMsm } from "./models/Interfaces/modalMessage";
import { Router } from "express";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { LoaderComponent } from "./components/shared/loader/loader.component";

// component ok
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.sass"],
  standalone: true,
  imports: [ FormsModule,CommonModule,ReactiveFormsModule, RouterModule,NgxUiLoaderModule,LoaderComponent ]
})
export class AppComponent implements OnInit {

  // public modalLoaderState: boolean = false;
  // public modalMessageState: boolean = false;
  // public dataMsm: ModalMessage;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private _sharedService: SharedService,
    private _i18n: I18nService
  ) {}

  ngOnInit() {
    // i18n: aplicar el idioma persistido (o el default) en toda la app
    this._i18n.init();
    // Nueva sesión de navegador → limpiar filtros de localStorage
    this._sharedService.resetFiltersIfNewSession();
    this.loadIconsApp();
  }
  
  // Función de Carga Inicial de Iconos
  private loadIconsApp() {
    let urlIconsStyle = environment.iconsUrl;
    this.document
      .getElementById("iconsApp")
      .setAttribute("href", urlIconsStyle);
  }

  /*------------------------------Inicio de Funciones Propias--------------------------*/

  // private changeStateModalLoader(data: boolean) {
  //   Promise.resolve(null).then(() => (this.modalLoaderState = data));
  // }

  // private changeStateModalMessage(data: ModalMessage) {
  //   this.dataMsm = data;
  //   Promise.resolve(null).then(() => (this.modalMessageState = true));
  //   if (data.typeMsm != TypeMsm.confirm)
  //     setTimeout(() => (this.modalMessageState = false), 6500);
  // }

  // public closeModal() {
  //   Promise.resolve(null).then(() => (this.modalMessageState = false));
  // }

  // private listenerEvents() {
  //   SharedService.changeStateModalLoaderEmitter.subscribe((data) =>
  //     this.changeStateModalLoader(data)
  //   );
  //   SharedService.changeStateModalMessageEmitter.subscribe((data) =>
  //     this.changeStateModalMessage(data)
  //   );
  //   SharedService.closeModalMessageEmitter.subscribe((data) =>
  //     this.closeModal()
  //   );
  // }
  /*------------------------------Fin de Funciones Propias--------------------------*/
}
